    <div class="space-y-6 w-full max-w-full overflow-x-hidden">
      <!-- Header -->
      <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 w-full">
        <div>
          <h2 class="text-xl font-semibold text-gray-900">Domande</h2>
          <p class="mt-1 text-sm text-gray-500">
            {{ questionCountFromDb}}/6 domande aggiunte
          </p>
        </div>
      </div>

      <!-- Questions List -->
      <div class="space-y-4 w-full overflow-x-hidden">
        @for (question of questions; track question.queryId; let i = $index) {
          <div class="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200 w-full">
            <div class="flex flex-col space-y-4 w-full">
              <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-2">
                <div class="flex items-center space-x-3">
                  <span class="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-lg font-semibold"
                        [ngClass]="{
                          'bg-primary-light text-primary-dark': question.type === '1',
                          'bg-secondary-light/10 text-secondary': question.type === '2',
                          'bg-gray-100 text-gray-800': question.type === '21'
                        }">
                    {{ i + 1 }}
                  </span>
                  <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
                        [ngClass]="{
                          'bg-primary-light text-primary-dark': question.type === '1',
                          'bg-secondary-light/10 text-secondary': question.type === '2',
                          'bg-gray-100 text-gray-800': question.type === '21'
                        }">
                    type:{{ question.type}}:
                    {{ question.type === '21' ? 'Link Redirect' : QUESTION_TYPE_LABELS[question.type] }}
                    {{ question.type === '4' ? 'Possibili risposte' : QUESTION_TYPE_LABELS[question.type] }}
                  </span>
                </div>
                <div class="flex items-center gap-2 w-full sm:w-auto justify-end">
                  <button
                    type="button"
                    (click)="startEdit(question)"
                    class="inline-flex items-center p-2 border border-transparent rounded-lg text-secondary hover:bg-secondary-light/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition-colors"
                    title="Modifica domanda"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    (click)="removeQuestion(question.queryId)"
                    class="inline-flex items-center p-2 border border-transparent rounded-lg text-secondary hover:bg-secondary-light/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition-colors"
                    title="Elimina domanda"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>

              @if (editingQuestionQueryId === question.queryId) {
                <form [formGroup]="editForm" (ngSubmit)="saveEdit(question)" class="mt-2 space-y-4 w-full">
                  <!-- Question Type Selection -->
                  @if (question.type !== '21') {
                    <div class="flex flex-wrap gap-2">
                      @for (type of questionTypes; track type) {
                        <button
                          type="button"
                          (click)="selectEditType(type)"
                          class="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center px-4 py-2 border rounded-lg text-sm font-medium transition-all"
                          [class]="editForm.get('type')?.value === type
                            ? 'border-primary bg-primary-light text-primary-dark'
                            : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'"
                        >
                          {{ QUESTION_TYPE_LABELS[type] }}
                        </button>
                      }
                    </div>
                  }
                  <!-- Question Title Input -->
                  <div class="flex flex-col gap-2">
                    <input
                      type="text"
                      formControlName="title"
                      class="flex-1 shadow-sm focus:ring-primary focus:border-primary block w-full text-base border-gray-300 rounded-lg"
                      [placeholder]="question.type === '21' ? 'Inserisci il titolo della domanda' : 'Inserisci il testo della domanda'"
                    />
                    @if (question.type === '21') {
                      <input
                        type="url"
                        formControlName="url"
                        class="flex-1 shadow-sm focus:ring-primary focus:border-primary block w-full text-base border-gray-300 rounded-lg"
                        placeholder="inserisci URL"
                      />
                    }
                    <div class="flex gap-2">
                      <button
                        type="submit"
                        [disabled]="!editForm.valid"
                        class="flex-1 sm:flex-none inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-secondary hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary disabled:bg-gray-400 disabled:cursor-not-allowed transition-all"
                      >
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        Salva
                      </button>
                      <button
                        type="button"
                        (click)="cancelEdit()"
                        class="flex-1 sm:flex-none inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all"
                      >
                        Annulla
                      </button>
                    </div>
                  </div>
                </form>
              } @else {
                <p class="text-base text-gray-900">{{ question.title }}</p>
                @if (question.type === '21') {
                  <p class="text-sm text-gray-500">{{ question.url }}</p>
                }
                @if (question.type === '4') {
                  <p class="text-sm text-gray-500">Possibili risposte:{{ question.responseType }}</p>
                }
              }
            </div>
          </div>
        }
      </div>

      <!-- Add Question Form -->
      @if (questionCountFromDb < 6) {
        <form [formGroup]="questionForm" (ngSubmit)="addQuestion()" class="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
          <div class="space-y-6">
            <!-- Question Type -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">Tipo di Domanda</label>
              <div class="flex flex-wrap gap-2">
                @for (type of questionTypes; track type) {
                  <button
                    type="button"
                    (click)="selectType(type)"
                    class="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center px-4 py-2.5 border rounded-lg text-base font-medium transition-all"
                    [class]="questionForm.get('type')?.value === type
                      ? 'border-primary bg-primary-light text-primary-dark'
                      : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'"
                  >
                    {{ QUESTION_TYPE_LABELS[type] }}
                  </button>
                }
              </div>
            </div>

            <!-- Question Title -->
            <div>
              <label for="title" class="block text-sm font-medium text-gray-700 mb-2">
                Testo della Domanda
              </label>
              <div class="flex flex-col md:flex-row gap-2">
                <input
                  type="text"
                  id="title"
                  formControlName="title"
                  class="w-full shadow-sm focus:ring-primary focus:border-primary block text-base border-gray-300 rounded-lg"
                  [placeholder]="getPlaceholder()"
                />
                <!-- Solo se è una domanda custom -->
                @if (questionForm.get('type')?.value === '4') {
                    <label for="responseType" class="block text-sm font-medium text-gray-700 mb-2 mt-4">
                      Possibili Risposte (separate da pipe)
                    </label>
                    <input
                      type="text"
                      id="responseType"
                      formControlName="responseType"
                      class="w-full shadow-sm focus:ring-primary focus:border-primary block text-base border-gray-300 rounded-lg"
                      placeholder="es: opzione 1|opzione 2|opzione 3"
                    />
                }

                @if (questionForm.get('type')?.value === '21') {
                   <div class="space-y-6">
                      <div>
                        <label for="url" class="block text-sm font-medium text-gray-700 mb-2">
                          URL di Redirect
                        </label>
                        <input
                          type="url"
                          id="url"
                          formControlName="url"
                          class="shadow-sm focus:ring-primary focus:border-primary block w-full text-base border-gray-300 rounded-lg"
                          placeholder="inserisci URL"
                        />
                        @if (urlForm.get('url')?.touched && urlForm.get('url')?.errors?.['required']) {
                          <p class="mt-2 text-sm text-red-600">L'URL è obbligatorio</p>
                        }
                      </div>
                  </div>
                }

                <button
                  type="submit"
                  [disabled]="!questionForm.valid"
                  class="w-full md:w-auto inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-secondary hover:bg-secondary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary disabled:bg-gray-400 disabled:cursor-not-allowed transition-all touch-manipulation"
                >
                  <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                  </svg>
                  Aggiungi Domanda
                </button>
              </div>
              @if (questionForm.get('title')?.touched && questionForm.get('title')?.errors?.['required']) {
                <p class="mt-2 text-sm text-red-600">Il testo della domanda è obbligatorio</p>
              }
            </div>
          </div>
        </form>

      }

      <!-- URL Input Form -->

      <!-- Azioni finali -->
      <div class="flex justify-between mt-12">
        <!-- 🔙 Bottone "Torna alla lista" -->
        <button
          (click)="cancel.emit()"
          class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition"
        >
          Torna alla lista
        </button>

        <!-- 💾 Bottone "Salva Domande" -->
        <button
          (click)="onSave()"
          class="inline-flex items-center justify-center px-6 py-2.5 border border-green-600 text-base font-medium rounded-lg shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 transition-all"
        >
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          Salva Domande
        </button>
      </div>


    </div>